'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dSigner$002dRole from "./presto.types$-Signer-Role.js";
var $p;
/** @constructor */
function $c_Lpresto_types$SignerRole$$anon$30(_$ordinal$25, \u03b4name$25, outer) {
  this.cxG = 0;
  this.a9B = null;
  this.cxG = _$ordinal$25;
  this.a9B = \u03b4name$25;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
}
export { $c_Lpresto_types$SignerRole$$anon$30 as $c_Lpresto_types$SignerRole$$anon$30 };
$p = $c_Lpresto_types$SignerRole$$anon$30.prototype = new $j_presto$002etypes$0024$002dSigner$002dRole.$h_Lpresto_types$SignerRole();
$p.constructor = $c_Lpresto_types$SignerRole$$anon$30;
/** @constructor */
function $h_Lpresto_types$SignerRole$$anon$30() {
}
export { $h_Lpresto_types$SignerRole$$anon$30 as $h_Lpresto_types$SignerRole$$anon$30 };
$h_Lpresto_types$SignerRole$$anon$30.prototype = $p;
$p.r = (function() {
  return 0;
});
$p.j = (function(n) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_sr_EnumValue__productElement__I__O(this, n);
});
$p.s = (function() {
  return this.a9B;
});
$p.l = (function() {
  return this.a9B;
});
var $d_Lpresto_types$SignerRole$$anon$30 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$SignerRole$$anon$30, "presto.types$SignerRole$$anon$30", ({
  a1Z: 1,
  k9: 1,
  b: 1,
  c: 1,
  a: 1,
  q: 1,
  s: 1,
  e: 1,
  g: 1,
  m: 1
}));
export { $d_Lpresto_types$SignerRole$$anon$30 as $d_Lpresto_types$SignerRole$$anon$30 };
//# sourceMappingURL=presto.types$-Signer-Role$$anon$30.js.map
